/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames';

import { AppContext } from '../../AppContext'
import InviteUser from './InviteUser.js'
import UserList from './UserList.js'
import EnrollUser from './EnrollUser.js'

class UserAdmin extends React.Component
{
  tabTypes = ['list', 'invite']
  activeTabKey = 'userAdmin.activeTab';

  componentDidMount()
  {
    var activeTab = Number(this.context.appLocalStorage.getItem(this.activeTabKey));
    if (undefined === activeTab || null === activeTab) activeTab = 0;
  }

  constructor(props)
  {
    super();

    this.state =
    {
      tabIndex: 0
    }

    this.toggleTab = this.toggleTab.bind(this);
  }

  render()
  {
    let appContext = this.context;

    document.title = this.context.websiteProfile.profileName + ': User Admin';

    let inviteDisabled = true;

    return(
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 0 })}
              onClick={() => { this.toggleTab(0); }}
            >
              User List
            </NavLink>
          </NavItem>
        {( 'Y' === appContext.websiteProfile.allowNewUsers && 'Y' === appContext.websiteProfile.smtpEnabled && !inviteDisabled &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 1 })}
              onClick={() => { this.toggleTab(1); }}
            >
              Invite
            </NavLink>
          </NavItem>
        )}
        {( 'Y' === appContext.websiteProfile.allowNewUsers &&
          <NavItem>
            <NavLink className={classnames({ active: this.state.tabIndex === 2 })}
              onClick={() => { this.toggleTab(2); }}
            >
              Enroll
            </NavLink>
          </NavItem>
        )}
        </Nav>
        <TabContent activeTab={this.state.tabIndex}>
          <TabPane tabId={0}>
            <UserList  tabId={0} tabIndex={this.state.tabIndex} />
          </TabPane>
        {( 'Y' === appContext.websiteProfile.allowNewUsers && !inviteDisabled &&
          <TabPane tabId={1}>
            <InviteUser tabId={1} tabIndex={this.state.tabIndex} />
          </TabPane> 
        )}
        {( 'Y' === appContext.websiteProfile.allowNewUsers &&
          <TabPane tabId={2}>
            <EnrollUser  tabId={2} tabIndex={this.state.tabIndex} />
          </TabPane> 
        )}
        </TabContent>
      </div>
    );
  }

  toggleTab(tabIndex, tab)
  {
    if (this.state.tabIndex !== tabIndex)
    {
      this.setState({ tabIndex: tabIndex });
      this.context.appLocalStorage.setItem(this.activeTabKey, tabIndex);
    } 
  }
}

UserAdmin.contextType = AppContext;

export default UserAdmin